"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typedown = _interopRequireDefault(require("../Typedown"));
var _typedownHooks = require("../hooks/typedownHooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const QueryTypedown = _ref => {
  let {
    dataFormatter = d => d,
    path,
    pathMutator,
    ...rest
  } = _ref;
  const [callPath, setCallPath] = (0, _react.useState)(pathMutator(null, path));
  const data = dataFormatter((0, _typedownHooks.useTypedownData)(path, callPath));
  const [userQuery, setUserQuery] = (0, _react.useState)('');
  const onType = e => {
    setUserQuery(e.target.value);
  };
  (0, _react.useEffect)(() => {
    setCallPath(pathMutator(userQuery, path));
  }, [path, pathMutator, userQuery]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typedown.default, {
    ...rest,
    dataOptions: data,
    onType: onType
  });
};
QueryTypedown.propTypes = {
  dataFormatter: _propTypes.default.func,
  path: _propTypes.default.string,
  pathMutator: _propTypes.default.func
};
var _default = exports.default = QueryTypedown;